import {
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData
} from "model/FlexibleAttributeModel";
import { blankSnapshot } from "model/snapshotTemplate";
import { BaseJsonTransformer } from "./IJsonTransformer";

export class UpdateIterationTransformer extends BaseJsonTransformer {
    readonly release: FAM_IGroupConfigurationConfig;
    /**
     *
     */
    constructor(release: FAM_IGroupConfigurationConfig) {
        super();
        this.release = release;
    }

    async after(json: FAM_IGroupConfigurationData): Promise<void> {

        json.iteration = blankSnapshot().iteration;
        const bcbs_config_release = this.release.bcbs_config_release;

        json.releaseRef = {
            id: bcbs_config_release.bcbs_config_releaseid!,
            name: bcbs_config_release.bcbs_name!,
        }
        json.releaseVersion = bcbs_config_release.bcbs_versionnumber;

        console.log('[tran] UpdateIterationTransformer.after', {
            iteration: json.iteration,
            release: {
                name: bcbs_config_release.bcbs_name,
                id: bcbs_config_release.bcbs_config_releaseid,
                bcbs_versionnumber: bcbs_config_release.bcbs_versionnumber
            },
            jsonReleaseVersion: json.releaseVersion
        });
    }
}